import * as React from "react";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import Toast from "../../helper/Toast";
import User from "../../../model/user/User";
import {Option} from "ts-option";
import {RootState} from "../../../store/reducer/root/RootState";
import {getUser} from "../../../store/view/user";
import Job from "../../../model/job/Job";
import Watchers from "../../lead/v4/Watchers";
import {updateJobWatchers} from "../../../store/action/job/job";

interface ComponentProps {
	/**
	 * Job.
	 */
	job: Option<Job>
}

interface ReduxProps {
	/**
	 * Job watchers.
	 */
	watchers: User[]
}

interface DispatchProps {
	/**
	 * Update watchers action.
	 * @param {string} jobId
	 * @param {string[]} watchers
	 */
	updateWatchers: (jobId: string, watchers: string[]) => void;
}


type Props = ComponentProps & DispatchProps & ReduxProps

class JobWatchers extends React.PureComponent<Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onUpdate = this.onUpdate.bind(this);
	}

	render() {
		return (
			<Watchers watchers={this.props.watchers} onUpdateWatchers={this.onUpdate}/>
		);
	}

	onUpdate(updatedWatchers: string[]) {
		this.props.job.map(l => {
			this.props.updateWatchers(l.id, updatedWatchers);
		})
	}

}

function mapStateToProps(state: RootState, props: ComponentProps) {
	const watchersIds = props.job.map(job => job.watchers).getOrElse([]);
	return {
		watchers: watchersIds.map(wId => getUser(wId)).filter(u => u.isDefined).map(u => u.get)
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateWatchers: (jobId: string, watchers: string[]) => dispatch(
			updateJobWatchers(
				jobId,
				watchers,
				() => Toast.success("Job watchers updated", "Job details update"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Job details update"))
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(JobWatchers)